export default {
  description: state => state.description,
  products: state => state.products,
  tpl: state => state.tpl,
  productsCount: state => state.total,
  productsPerPage: state => state.productsPerPage
};